var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDragDrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03.-Icons/24px/drag&drop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,14.25 C17.4142136,14.25 17.75,14.5857864 17.75,15 C17.75,15.3796958 17.4678461,15.693491 17.1017706,15.7431534 L17,15.75 L6,15.75 C5.58578644,15.75 5.25,15.4142136 5.25,15 C5.25,14.6203042 5.53215388,14.306509 5.89822944,14.2568466 L6,14.25 L17,14.25 Z M17,9.25 C17.4142136,9.25 17.75,9.58578644 17.75,10 C17.75,10.3796958 17.4678461,10.693491 17.1017706,10.7431534 L17,10.75 L6,10.75 C5.58578644,10.75 5.25,10.4142136 5.25,10 C5.25,9.62030423 5.53215388,9.30650904 5.89822944,9.25684662 L6,9.25 L17,9.25 Z",
    id: "ic_drag&drop",
    fill: "#778699",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDragDrop);
export default __webpack_public_path__ + "static/media/icon-drag-drop.67d243c0077a4097e14d7cb4264db471.svg";
export { ForwardRef as ReactComponent };